import React, { useEffect, useState } from "react";
import { errorNotification } from "../Generic/Notifications";
import { Table, Tbody, Tcol, Thead, Trow } from "../Generic/Table";
import EmptyState from "../Generic/EmptyState";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { beautifyKey } from "../util/util";
import Loader from "../Generic/Loader";
import InventoryPlanService from "./Services/InventoryPlanService";

const Page = styled.div`
	display: flex;
	height: max-content;
	overflow-y: auto;
	flex-direction: column;
	text-align: left;
	width: 100%;
	padding: 1rem;
`;

const Header = styled.div`
	display: flex;
	font-size: 2rem;
	font-weight: 600;
	margin: 1rem 0 0 0.5rem;
`;

const CenteredContainer = styled.div`
	width: 100%;
	height: max-content;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: ${(props) => props.margin};
`;

function dateToString(date) {
	return new Date(date).toLocaleString();
}

const InventoryPlans = (props) => {
	const { machineID } = props;

	const [inventoryPlans, setInventoryPlans] = useState([]);
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);

	async function getReplenishmentPlans() {
		setLoading(true);
		const response = await InventoryPlanService.getInventoryPlans(machineID);
		setLoading(false);
		const { data, error } = response;
		if (data) {
			setInventoryPlans(data);
		}
		if (error) {
			errorNotification(error);
		}
	}

	function navigateToTaskPage(taskId) {
		navigate(`/${machineID}/inventoryPlan/details/${taskId}`);
	}

	function renderTaskList(tasks) {
		if (tasks.length) {
			let tasksRenderData = tasks.map((task) => {
				const { _id, name, createdAt } = task;
				return (
					<Trow hoverEffect={false} onClick={() => navigateToTaskPage(_id)} >
						<Tcol borderRadius="10px 0 0 10px">{name}</Tcol>
						<Tcol borderRadius="0 10px 10px 0">{dateToString(createdAt)}</Tcol>
					</Trow>
				);
			});

			return(
				<Table>
					<Trow head>
						<Thead>Name</Thead>
						<Thead>Created At</Thead>
					</Trow>
					<Tbody>
						{tasksRenderData}
					</Tbody>
				</Table>
			)

		} else {
			return <EmptyState retry={getReplenishmentPlans} />;
		}
	}

	useEffect(() => {
		getReplenishmentPlans();
	}, []);

	return (
		<Page>
			<Header>Inventory Plans</Header>
			{!loading ? renderTaskList(inventoryPlans) : ""}
			{loading ? (
				<CenteredContainer>
					<Loader />
				</CenteredContainer>
			) : (
				""
			)}
		</Page>
	);
};

const mapStateToProps = (state) => {
	const { landing } = state;
	return { ...landing };
};

const mapDispatchToProps = (dispatch) => ({
	...bindActionCreators({}, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(InventoryPlans);
